/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgItemReciept = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M6 17.003V12h2v5.003zm10 0V12h2v5.003zm-3-4.988v5.003h-2v-5.003zM10 12v5.003H9V12zm4.969.015v5.003h-1v-5.003z" />
        <path d="M2 2h20v19H2zm2 2v15h16V4zm14 4H6V6h12z" />
      </g>
    </g>
  </Icon>
);
export { SvgItemReciept as ItemReciept };
